<template>
  <div class="wrap">
    <p class="required-title">{{$t("deTopic.derivative.t31")}}</p>
    <div class="list">
      <template v-for="(item, index) in topicList">
        <div class="item" v-if="item.show" :key="index">
          <InvestigateTopic :itemData="item"></InvestigateTopic>
          <!--   是否包含二级题目  且 是否 满足显示题目条件        -->
          <template
            v-if="
              item.child &&
                item.child.length > 0 &&
                item.showChild === item.answer
            "
          >
            <p class="child-tips" v-if="item.childTips">{{ item.childTips }}</p>
            <template v-for="(cItem, cIndex) in item.child">
              <div class="child" :key="cIndex">
                <InvestigateTopic :itemData="cItem"></InvestigateTopic>
              </div>
            </template>
          </template>
        </div>
      </template>
    </div>
    <div class="btn-submit" :class="{ dis: submitIsDis }" @click="submit">
      {{ $t("common.next_step") }}
    </div>
  </div>
</template>

<script>
import InvestigateTopic from "@/views/create-account/components/InvestigateTopic.vue";

export default {
  components: {
    InvestigateTopic
  },
  computed: {
    // 校验是否可以提交 下一步
    submitIsDis() {
      const { topicList } = this;
      let result = false;
      topicList.map(item => {
        if (item.show) {
          // 当这个提  是必填  而且 答案是不能填的答案 或者 答案是空的时候  是不能提交的
          if (
            item.isRequired &&
            (item.answer == item.requireTipsAnswer || item.answer === "" || item.answer.length === 0)
          ) {
            result = true;
          }
          if (
            item.child &&
            item.child.length > 0 &&
            item.showChild === item.answer
          ) {
            // 第一题 四个小题 必选一题 单独处理
            if (item.key == "derivative") {
              // 数组：长度大于0  非数组：不为空
              const _is = item.child.find(
                cItem =>
                  (Array.isArray(cItem.answer) && cItem.answer.length > 0) ||
                  (!Array.isArray(cItem.answer) && cItem.answer !== "")
              ); // 查找是否包含了 填写答案 的题  有就可以通过
              // 第一题的二级题目 答了一个 就可以了
              result = !_is;
            } else {
              item.child.map(cItem => {
                if (
                  cItem.isRequired &&
                  (cItem.answer == cItem.requireTipsAnswer || cItem.answer === "" || cItem.answer.length === 0)
                ) {
                  result = true;
                }
              });
            }
          }
        }
      });
      return result;
    }
  },
  // topicList 题目列表
  data() {
    return {
      openType: 1, // 1 开了期货账号，加开证券账号  2 开了证券账号，加开期货账号 3 了期货账号，加开期货账号  路由地址会带过来的参数
      topicList: [
        {
          key: "derivative", // 题目 归类 服务端
          id: "t0", // 题目id 模拟
          show: true, // 当前题目 是否显示 （不同类型入口，显示题目不一样）
          title: this.$t("deTopic.derivative.t0"), // 标题
          isRequired: true, // 是否必填
          requireTips: this.$t("deTopic.derivative.t3"), // 必填为空 或者答案不对时 的提示
          requireTipsAnswer: 1, // 此答案不通过 则会提示 requireTips 字段信息
          type: "radio", // 题目类型
          options: [
            { title: this.$t("deTopic.derivative.t1"), value: 0 },
            { title: this.$t("deTopic.derivative.t2"), value: 1 }
          ], // 选项
          answer: "", // 当前题目的 选择或输入 答案
          showChild: 0, // 显示 子题目 的条件  0 显示(了解) 1 不显示(不了解)
          childTips: this.$t("deTopic.derivative.t4"), // 二级题目 提示
          child: [
            {
              id: 11,
              title: this.$t("deTopic.derivative.t5"),
              type: "checkbox",
              answer: [],
              options: [
                { title: this.$t("deTopic.derivative.t6"), value: 0 },
                { title: this.$t("deTopic.derivative.t7"), value: 1 },
                { title: this.$t("deTopic.derivative.t8"), value: 2 },
                { title: this.$t("deTopic.derivative.t9"), value: 3 },
                { title: this.$t("deTopic.derivative.t10"), value: 4 }
              ]
            },
            {
              id: 12,
              title: this.$t("deTopic.derivative.t11"),
              type: "checkbox",
              answer: [],
              options: [
                { title: this.$t("deTopic.derivative.t12"), value: 0 },
                { title: this.$t("deTopic.derivative.t13"), value: 1 },
                { title: this.$t("deTopic.derivative.t14"), value: 2 }
              ]
            },
            {
              id: 13,
              title: this.$t("deTopic.derivative.t15"),
              type: "radio",
              answer: "",
              options: [
                { title: this.$t("deTopic.derivative.t16"), value: 0 },
                { title: this.$t("deTopic.derivative.t17"), value: 1 }
              ]
            },
            {
              id: 14,
              title: this.$t("deTopic.derivative.t18"),
              type: "upload",
              tips: this.$t("deTopic.derivative.t19"),
              maxCount: 6, // 最大上传文件数量
              fileList: [], // 上传的文件内容
              answer: [] // api 返回的内容 相对路径的 地址
            }
          ]
        },
        {
          key: "information",
          id: "t0",
          show: true,
          title: this.$t("deTopic.derivative.t20"),
          isRequired: true,
          type: "radio",
          options: [
            { title: this.$t("deTopic.derivative.t21"), value: 0 },
            { title: this.$t("deTopic.derivative.t22"), value: 1 }
          ],
          answer: "",
          showChild: 0, // 显示 子题目 的条件  1 显示(了解)  2 不显示(不了解)
          child: [
            {
              id: 21,
              title: this.$t("deTopic.derivative.t23"),
              type: "textarea",
              placeholder: this.$t("deTopic.derivative.t24"),
              answer: "",
              requireTipsAnswer: "",
              isRequired: true // 是否必填
            }
          ]
        },
        {
          key: "information",
          id: "t1",
          show: true,
          title: this.$t("deTopic.derivative.t25"),
          isRequired: true,
          requireTips: this.$t("deTopic.derivative.t26"),
          requireTipsAnswer: 1,
          type: "radio",
          options: [
            { title: this.$t("deTopic.derivative.t27"), value: 0 },
            { title: this.$t("deTopic.derivative.t28"), value: 1 }
          ],
          answer: ""
        },
        {
          key: "information",
          id: "t2",
          show: true,
          title: this.$t("deTopic.derivative.t29"),
          isRequired: true,
          type: "textarea",
          placeholder: this.$t("deTopic.derivative.t30"),
          answer: ""
        }
      ]
    };
  },
  created() {
    const { openType } = this.$route.query;
    this.openType = openType;
    // 针对性 设置题目 是否必选 显示等条件
    this.setTopicIsRequired();
  },
  methods: {
    setTopicIsRequired() {
      const { openType } = this;
      this.topicList[0].requireTipsAnswer = openType != 1 ? 1 : 2;
      this.topicList[3].show = openType == 3;
    },
    submit() {
      // 校验
      if (!this.submitIsDis) {
        const params = {
          derivative: {},
          information: {}
        };
        const { topicList } = this;
        // 答案 数据拼装
        topicList.map(item => {
          if (!params[item.key][item.id]) params[item.key][item.id] = {};
          params[item.key][item.id].value = item.answer;
          if (
            item.child &&
            item.child.length > 0 &&
            item.showChild === item.answer
          ) {
            item.child.map((cItem, cIndex) => {
              const cKey = "t" + cIndex;
              if (!params[item.key][item.id].children)
                params[item.key][item.id].children = {};
              params[item.key][item.id].children[cKey] = cItem.answer;
            });
          }
        });
        if(params.derivative?.t0?.children?.t3){
          params.derivative.relevant_vouchers = params.derivative?.t0?.children?.t3;
        }

        

        // 提交答案
        this.$apis.saveAccountDerivative(params).then(() => {
          const { openType, modify,fromChangInfoPage } = this.$route.query; // 如果是 加开
          // 加开不通过 -- 代办入口 进入的 -> 资料修改 -> 开始处理  进入的
          if(fromChangInfoPage && fromChangInfoPage == 1){
            const openTypeToSerId = {
              1: 6,
              2: 3,
              3: 3
            };
            const server_id = openTypeToSerId[openType];
            this.$apis
              .saveServerInfo({
                server_id
              })
              .then(res => {
                //   提交信息
                this.$router.push({
                  path: "/account-result",
                  query: this.$route.query
                })
              });
          }else{
            if (modify == "1") {
              this.$store.commit("failReason/SAVE_MODIFIED_FAIL_REASON", 6);
              this.$router.go(-1);
            } else {
              this.$router.push({
                path: "/customer-agreement1",
                query: this.$route.query
              });
            }
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.black-theme{
  .wrap{
    color: #fff;
    /deep/ .van-radio__label,/deep/ .van-field__control{
      color: #fff;
    }
  }
}
.wrap {
  overflow: hidden;
  position: relative;
  .required-title{
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 24px;
    line-height: 44px;
    color: #f69500;
  }
  .list {
    margin: 0 20px;
    .item {
      padding-top: 20px;
      border-bottom: #eee solid 1px;
      &:last-child {
        border: none;
      }
      .child-tips {
        padding-left: 20px;
        margin-bottom: 20px;
        color: #f69500;
        font-size: 26px;
      }
      .child {
        padding: 0 20px 20px;
        /deep/ .topic-box {
          padding: 0;
          .title {
            font-size: 28px;
            font-weight: normal;
            .required {
              //display: none;
            }
          }
          .van-radio-group,
          .van-checkbox-group {
            padding-left: 30px;
          }
        }
      }
    }
  }
  .btn-submit {
    margin: 40px 50px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    background: #1c0955;
    color: #fff;
    font-size: 32px;
    border-radius: 6px;
    &.dis {
      background: #aa9fcb;
    }
  }
}
.black-theme{
  .wrap{
    .btn-submit{
      background-color: #377CFB;
      &.dis {
        background: #aa9fcb;
      }
    }
  }
}

</style>
